interface Props {
    content: string;
    title?: string;
    styleOne?: string; 
}

export default function NotesPreview({ content, title = 'Preview:', styleOne = 'p-3' }: Props) {
    
    return (
        <div className={`rounded-md border border-dashed border-gray-300 bg-gray-50 ${styleOne} text-xs text-gray-600`}>
            <span className="font-semibold">{title}</span>
            <div className="ProseMirror mt-1" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    )
}